import { useAlarmTypeGroupsByName } from '@hakimo-ui/hakimo/data-access';
import { AlarmTypeGroupFilters } from '@hakimo-ui/hakimo/types';
import { SlideOver } from '@hakimo-ui/hakimo/ui-elements';
import {
  FilterFooter,
  FilterSection,
  MultiSelectFilter,
} from '@hakimo-ui/hakimo/ui-filters';
import { useState } from 'react';

interface Props {
  open: boolean;
  filters: AlarmTypeGroupFilters;
  onApplyFilters: (value: AlarmTypeGroupFilters) => void;
  onClose: () => void;
}

function FilterPanel(props: Props) {
  const { open, onClose, filters, onApplyFilters } = props;

  const [nameFilterValue, setNameFilterValue] = useState(filters.name);
  const getAlarmTypeGroupsByName = useAlarmTypeGroupsByName();

  const onApplyFiltersCb = () => {
    onApplyFilters({
      name: nameFilterValue,
    });

    onClose();
  };

  const onResetFilters = () => {
    setNameFilterValue({ values: [], negative: false });
  };

  return (
    <SlideOver title="Alarm Type Groups Filters" open={open} onClose={onClose}>
      <div className="space-y-6">
        <div className="dark:divide-dark-border-bg dark:border-dark-border-bg divide-y border-b border-t">
          <FilterSection
            title="Alarm Type Groups"
            content={
              <MultiSelectFilter
                value={nameFilterValue}
                label="Name"
                onChange={setNameFilterValue}
                getOptions={getAlarmTypeGroupsByName}
              />
            }
            hasFilterApplied={nameFilterValue.values.length > 0}
          />
        </div>
        <FilterFooter
          onApply={onApplyFiltersCb}
          onReset={onResetFilters}
          trackingEventNameApply="apply_alarm_type_group_filters"
          trackingEventNameReset="clear_alarm_type_group_filters"
        />
      </div>
    </SlideOver>
  );
}

export default FilterPanel;
